import React from 'react';
import { bool, func, string } from 'prop-types';
import moment from 'moment';
import DatePicker from 'react-datepicker';

const CustomInput = React.memo(({ value = '', onClick, onDateClick }) => {
  let dateValue = '';
  if (value && value !== 'Invalid date') {
    dateValue = value;
  }
  return (
    <button
      type="button"
      onClick={() => onDateClick(onClick)}
      className="distro__date-picker--control"
    >
      {dateValue || (
        <span className="distro__date-picker--control-placeholder">
          month-year
        </span>
      )}
    </button>
  );
});
CustomInput.propTypes = {
  value: string,
  onClick: func,
  onDateClick: func,
};

const CustomMonthRangePicker = ({ handleDateChange, isError = false }) => {
  const [selectedStartDate, setStartDate] = React.useState();
  const [selectedEndDate, setEndDate] = React.useState();
  const [focusOn, setFocus] = React.useState();

  const id = 'date';

  const onDateClick = (type, callback) => {
    setFocus(type);
    callback();
  };

  const removeFocus = () => {
    setFocus('');
  };

  const handleStartDate = sd => {
    let isEndDateSameAsStartDate = false;
    const endDate = selectedEndDate;
    if (endDate && sd > endDate) {
      isEndDateSameAsStartDate = true;
    }
    const ed = isEndDateSameAsStartDate ? sd : endDate;

    setStartDate(sd);
    setEndDate(ed);
    if (handleDateChange) {
      handleDateChange('from', sd);
      handleDateChange('to', ed);
    }
    removeFocus();
  };

  const handleEndDate = ed => {
    let sd = selectedStartDate;
    if (sd && ed < sd) {
      sd = ed;
    }
    setStartDate(sd);
    setEndDate(ed);
    if (handleDateChange) {
      handleDateChange('from', sd);
      handleDateChange('to', ed);
    }
    removeFocus();
  };

  let startDateColClass = 'distro__date-picker--col';
  if (!selectedStartDate && isError) {
    startDateColClass += ' distro__date-picker--col--error';
  }

  let endDateColClass = 'distro__date-picker--col';
  if (!selectedEndDate && isError) {
    endDateColClass += ' distro__date-picker--col--error';
  }

  if (focusOn === 'startDate') {
    startDateColClass += ' distro__date-picker--col--focus';
  }
  if (focusOn === 'endDate') {
    endDateColClass += ' distro__date-picker--col--focus';
  }
  return (
    <div className="custom-date-picker custom-month-picker">
      <div className="distro__date-picker--wrapper">
        <div className={startDateColClass}>
          <div className="custom-date-picker--element">
            <label
              className="distro__date-selector--label"
              htmlFor={`${id}_from`}
            >
              Month Start
            </label>
            <DatePicker
              selected={selectedStartDate}
              onChange={date => handleStartDate(date)}
              placeholderText="month-year"
              dateFormat="MMMM-yyyy"
              showMonthYearPicker
              className="distro__date-picker--control"
              id={`${id}_from`}
              name={`${id}_from`}
              onClickOutside={() => removeFocus()}
              selectsStart
              startDate={selectedStartDate}
              endDate={selectedEndDate}
              minDate={
                new Date(moment("12-01-2020", "MM-DD-YYYY"))
              }
              customInput={
                <CustomInput
                  onDateClick={event => onDateClick('startDate', event)}
                />
              }
              data-test = 'startDate'
            />
          </div>
        </div>
        <div className={endDateColClass}>
          <div className="custom-date-picker--element">
            <label
              className="distro__date-selector--label"
              htmlFor={`${id}_from`}
            >
              Month End
            </label>
            <DatePicker
              selected={selectedEndDate}
              onChange={date => handleEndDate(date)}
              placeholderText="month-year"
              dateFormat="MMMM-yyyy"
              showMonthYearPicker
              className="distro__date-picker--control"
              id={`${id}_to`}
              name={`${id}_to`}
              onClickOutside={() => removeFocus()}
              selectsEnd
              startDate={selectedStartDate}
              endDate={selectedEndDate}
              minDate={
                selectedStartDate ||
                new Date(moment("12-01-2020", "MM-DD-YYYY"))
              }
              customInput={
                <CustomInput
                  onDateClick={event => onDateClick('endDate', event)}
                />
              }
              data-test = 'endDate'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

CustomMonthRangePicker.propTypes = {
  handleDateChange: func,
  isError: bool,
};

export default CustomMonthRangePicker;
